import styled from "styled-components";

export const SectionContainer = styled.section`
  display: flex !important;
  flex-direction: column;
  background-color: #fbfaff;
  min-height: calc(100vh - 98px);
  justify-content: center;
  align-items: center;
  padding: 5.625rem 10%;
`;

export const MainTitle = styled.h1`
  color: #0d51f1;
  font-family: Campuni;
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
  max-width: 50%;
  text-align: center;

  @media screen and (max-width: 600px) {
    font-size: 1.875rem;
    max-width: 100%;
  }
`;

export const Content = styled.div`
  display: flex;
  padding: 16px 48px;
  max-width: calc(100vw - 48px);

  @media screen and (max-width: 600px) {
    max-width: calc(100% - 16px);
  }
`;
